import React from "react";

const EligibilityFailed = ({
  isEligibilityFailedOpen,
  closeEligibilityFailed,
  loanProductName,
  reasons,
  handleTryAnotherProduct,
  handleCloseEligibilityFailed,
}) => {
  if (!isEligibilityFailedOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
      {/* Retained 670px max-width structure with responsive viewport bounds */}
      <div className="bg-white shadow-xl w-full max-w-[670px] rounded-md p-5 sm:p-8 flex flex-col items-center text-center relative my-auto max-h-[90vh] transition-all">
        {/* Close Button */}
        <button
          onClick={closeEligibilityFailed}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 text-xl font-bold leading-none p-1"
          aria-label="Close modal"
        >
          &times;
        </button>

        {/* Icon */}
        <div className="mb-3 shrink-0">
          <img
            src="/failed.png"
            alt="Ineligible"
            className="w-12 h-12 object-contain"
          />
        </div>

        {/* Header & Subtitle */}
        <div className="w-full max-w-[500px]">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 break-words">
            Member Ineligible
          </h2>
          <p className="text-gray-600 text-xs sm:text-sm mb-4 leading-relaxed break-words">
            This member does not meet all the requirements and is not eligible
            to apply for a{" "}
            <span className="font-semibold text-gray-900">
              {loanProductName || "[loan_productname]"}
            </span>
          </p>
        </div>

        {/* Reasons List Container */}
        <div className="w-full bg-red-50 border border-red-200 p-4 rounded-md max-h-40 overflow-y-auto text-left mb-6">
          <p className="font-semibold text-red-600 text-xs sm:text-sm mb-2">
            Reasons:
          </p>

          {reasons && reasons.length > 0 ? (
            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-xs sm:text-sm">
              {reasons.map((reason, index) => (
                <li key={index} className="break-words">
                  {reason}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 text-xs sm:text-sm italic"></p>
          )}
        </div>

        {/* Action Button */}
        <div className="flex justify-center items-center w-full">
          <button
            onClick={handleCloseEligibilityFailed}
            className="w-full sm:w-[211px] h-[45px] sm:h-[49px] border border-[#074073] text-xs sm:text-sm text-[#074073] hover:bg-blue-50 rounded-md font-medium whitespace-nowrap transition-colors duration-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EligibilityFailed;
